/**
 * Phase 2L-A102 — EbookTeaser: compact LEFT-rail tile that sits
 * beside the "Do we service your area?" service-area lookup.
 *
 * Shows the 3D mockup (smaller than the previous full-section
 * version), a one-line headline, two bullets, and a single
 * "Get the free guide →" button that routes to `/free-guide` for
 * the full form. NO form on the homepage itself.
 */
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";

export default function EbookTeaser() {
  return (
    <aside
      data-testid="ebook-teaser"
      className="h-full flex flex-col rounded-3xl bg-gradient-to-br from-cyan-50 via-white to-slate-50 ring-1 ring-cyan-100 p-5 sm:p-6"
    >
      <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-cyan-700">
        Free Homeowner Guide
      </div>
      <div className="mt-3 grid grid-cols-[auto,1fr] gap-5 items-start">
        <img
          src="/ebook/ebook-3d-cover-transparent.png"
          alt="The Australian Homeowner's Guide to Tank & Bore Water Testing — free AWARE Water Testing ebook"
          loading="lazy"
          width="140"
          height="198"
          data-testid="ebook-teaser-image"
          className="w-32 sm:w-36 drop-shadow-[0_18px_25px_rgba(8,47,73,0.25)]"
          style={{ transform: "rotate(10deg)", transformOrigin: "center" }}
        />
        <div className="min-w-0">
          <h3
            data-testid="ebook-teaser-headline"
            className="font-display text-lg sm:text-xl font-bold text-slate-900 leading-snug"
          >
            Tank &amp; Bore Water Testing Guide
          </h3>
          <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">
            What to test, when testing matters, and how to read your results.
          </p>
        </div>
      </div>
      <div className="mt-auto pt-5">
        <Link
          to="/free-guide"
          data-testid="ebook-teaser-cta"
          className="group inline-flex items-center justify-center gap-2 w-full rounded-full bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-5 py-3 text-sm transition"
        >
          <BookOpen className="w-4 h-4" />
          Get the free guide
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </aside>
  );
}
